import { render, staticRenderFns } from "./TeamRanking.vue?vue&type=template&id=7dbe89d8&scoped=true"
import script from "./TeamRanking.vue?vue&type=script&lang=js"
export * from "./TeamRanking.vue?vue&type=script&lang=js"
import style0 from "./TeamRanking.vue?vue&type=style&index=0&id=7dbe89d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe89d8",
  null
  
)

export default component.exports